import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

import { useResolveShortCodeToDealOpportunityLink } from "@vega-api/generated/deal-opportunity-lp-view/deal-opportunity-lp-view";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";

import { CommonPaths } from "../../paths";

export const DealOpportunityShortCode = () => {
  const navigate = useNavigate();
  const { shortCode: shortCodeParams } = useParams();

  const {
    data: shortCodeResponse,
    isPending,
    isError,
  } = useResolveShortCodeToDealOpportunityLink(
    {
      "short-code": String(shortCodeParams || ""),
    },
    {
      query: {
        enabled: !!shortCodeParams,
        refetchOnWindowFocus: false,
        select: (response) => response.data,
      },
    },
  );

  useEffect(() => {
    if (isPending) {
      return;
    }

    if (isError || !shortCodeParams) {
      navigate(CommonPaths.NotFound);

      return;
    }

    // remove origin from dealLink (i.e. path only), useNavigate does not support full URLs
    const dealLink = shortCodeResponse.dealLink;
    const dealLinkUrlObj = new URL(dealLink);
    const pathOnlyDealLink = dealLink.replace(dealLinkUrlObj.origin, "");

    navigate(pathOnlyDealLink, { replace: true });
  }, [isPending, isError, shortCodeParams, shortCodeResponse, navigate]);

  if (isPending) {
    return <LoadingSpinner />;
  }

  return null;
};
